import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import ApiService2 from '../../../POS/services/apiService';
import { toast } from 'react-toastify';
import userManagement from '../../../POS/services/userManagement';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import ItemlistGrid from '../issueItems/itemsGrid';
import IssueAuthorization from '../issueItems/issueAuthorization';
import IssueMessageGrid from '../issueItems/IssueMessage';
import DirectPurchaseGrid from '../DirectPurchase/directPurchaseGrid';
import StockAdjGrid from './stockAdjustmentGrid';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import { getCompany, getUserId, getUserName } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const CreateStockAdj = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL

    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const { currencyPrecision } = useCurrency();
    const [messageData, setMessageData] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [currency, setCurrency] = useState([]);
    const [department, setDepartment] = useState([]);
    const [Location, setLocation] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [userData, setUserdata] = useState([]);
    let navigate = useNavigate();
    const currentDatetimeUTC = new Date().toISOString();
    const location = useLocation();
    const itemData = location.state;
    const [POData, setPOData] = useState([]);
    const [POTab, setPOTab] = useState(true);
    const [loader, setLoader] = useState(false);
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const handleClose = () => setAttachmentModal(false);
    const handleOpen = () => setAttachmentModal(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);

    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);

    const todayDate = new Date().toISOString().substr(0, 10);
    const [formData, setFormData] = useState({
        requisitionNo: "",
        itemType: "",
        quatotionNo: "",
        remarks: "",
        requestor: "",
        requisitionDate: currentDatetimeUTC,
        deliveryDate: todayDate,
        currencyCode: "",
        exchangeRate: "",
        department: '',
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        deliveryPoint: "",
        location: [],
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
        adjNo: '',
        adjReason: '',

    });

    useEffect(() => {
        getApprovalUser()
        getCurrency()
        getLocation()
        getDepartment()
    }, [])
    useEffect(() => {
        const item = location.state;
        setFormData({
            recordId: item?.recordId,
            requisitionDate: item?.requisitionDate || currentDatetimeUTC,
            deliveryDate: item?.deliveryDate ? item.deliveryDate.substr(0, 10) : todayDate,
            requisitionNo: item?.requisitionNo,
            itemType: item?.type,
            quatotionNo: item?.contractNo,
            remarks: item?.remarks,
            requestor: item?.requestor,
            currencyCode: item?.currencyCode,
            costCenter2: item?.costCenter2,
            costCenter3: item?.costCenter3,
            costCenter4: item?.costCenter4,
            deliveryPoint: item?.deliveryPoint,
            contactPerson: item?.contactPerson,
            contatNo: item?.contatNo,
            taskCode: item?.projectCode,
            location: item?.location,
        });
        const selectedDepartment = department?.find(dep => dep.description === item?.department)
        if (selectedDepartment) {
            setFormData(prevState => ({
                ...prevState,
                department: { label: selectedDepartment.description, value: selectedDepartment }
            }));
        }
        const selectedLocation = Location?.find(dep => dep.location === item?.costCenter1)
        if (selectedLocation) {
            setFormData(prevState => ({
                ...prevState,
                costCenter1: { label: selectedLocation.location, value: selectedLocation }
            }));
        }
    }, [location?.state, department, Location]);
    const getApprovalUser = async () => {
        try {
            let docParam = `?TypeOfDoc=ADJ&DocId=ADJ`
            const docRes = await apiService.getApiParamater("GET_DOC_ID", docParam);
            setPOData(docRes?.data?.result[0].docId)
            const params = new URLSearchParams();
            params.append('DocNo', '');
            params.append('DocumentType', "ADJ");
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    let param = `?isActive=true`
    const getCurrency = async () => {
        if (currencyPrecision) {
            setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
            setFormData({ ...formData, exchangeRate: currencyPrecision?.conversionRate });
        }
    }
    const getLocation = async () => {
        let wareparam = `?Exp3=1`
        let res = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', wareparam)
        setLocation(res?.data?.result)
        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1([{ value: null, description: 'None' }, ...cost1.data.result]);

        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2([{ value: null, description: 'None' }, ...cost2.data.result]);

        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3([{ value: null, description: 'None' }, ...cost3.data.result]);

        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4([{ value: null, description: 'None' }, ...cost4.data.result]);
    }
    const GenerateNumber = async () => {
        let docParam = `?TypeOfDoc=ADJ&DocId=ADJ`
        const DocId = await apiService.getApiParamater("GET_DOC_ID", docParam);
        setFormData({ ...formData, adjNo: DocId?.data.result[0].docId });
        onCloseModal()
    }
    const getDepartment = async () => {
        let res = await apiService.getApiParamater('GET_DEPARTMENT_MASTER', param)
        setDepartment(res?.data?.result)
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility?.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const staticOptions = [
        { name: 'Wastage', label: 'Wastage' }
    ];
    const CreatePR = async () => {
        try {
            
            setLoader(true);
            if (!formData?.location?.label) {
                toast.warning("Select location");
                setLoader(false);
                return;
            } else if (!formData?.adjReason?.label) {
                toast.warning("Select Adjustment Reason");
                setLoader(false);
                return;
            } else if (!formData?.remarks) {
                toast.warning("Enter Remarks");
                setLoader(false);
                return;
            }
            for (const item of requisitionData) {
                if (!item.itemDescription) {
                    toast.warning(`Please Select Item`);
                    setLoader(false);
                    return;
                } else if (!item.qty) {
                    toast.warning(`Please enter ${item.itemDescription} quantity`);
                    setLoader(false);
                    return;
                } else if (item.stock === "0") {
                    toast.warning(`${item.itemDescription} not available in this location`);
                    setLoader(false);
                    return;
                }
            }
            
            const currentDatetimeUTC = new Date().toISOString();
            const apiService = new ApiService()
            const totalAmount = requisitionData?.reduce((sum, row) => sum + (row.amount || 0), 0);
            const GRNDetailsData = requisitionData?.map((item, index) => ({
                adjNo: POData,
                srno: index + 1,
                itemCode: item?.itemNo,
                itemDescription: item?.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.baseQty),
                specification: item.specification,
                convValue: parseFloat(item?.baseQty),
                unitPrice: Number(item.baseAmount).toFixed(currencyPrecision || 3),
                amount: Number(item.amount).toFixed(currencyPrecision || 3),
                baseAmount: Number(item.amount).toFixed(currencyPrecision || 3),
                convToInvUOM: parseFloat(item.baseQty),
                importedQty: 0,
                prodDate: currentDatetimeUTC,
                expDate: item.expDate,
                isActive: true,
                remarks: item.remarks
            }));
            const userData = {
                costCenter1: formData?.costCenter1?.label,
                costCenter2: formData?.costCenter2?.label,
                costCenter3: formData?.costCenter3?.label,
                costCenter4: formData?.costCenter4?.label,
                adjDetails: GRNDetailsData,
                location: formData?.location?.label,
                adjNo: POData,
                adjDate: currentDatetimeUTC,
                adjReason: formData?.adjReason?.label,
                warehouse: formData?.location?.label,
                currencyCode: SelectedCurrency?.label,
                exchangeRate: SelectedCurrency?.value?.conversionRate,
                baseAmount: Number(totalAmount).toFixed(currencyPrecision || 3),
                amount: Number(totalAmount).toFixed(currencyPrecision || 3),
                status: 0,
                approvalDate: formData?.deliveryDate,
                remarks: formData?.remarks,
                modifiedBy: userName,
            };

            const response = await apiService.post("CREATE_ADJUSTMENT", userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "ADJ",
                    docId: POData,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: "ADJ",
                    typeOfDoc: "ADJ",
                };
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);

                const token = localStorage.getItem("Token");
                const DB = localStorage.getItem("DataBase")
                if (!token) {
                    alert("Auth token is missing! Unable to proceed.");
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    "",
                    "ReportPopup",
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action =
                        REPORT_URL;
                    form.target = "ReportPopup";

                    const inputs = [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "StockAdjustment" },
                        { name: "voucherNo", value: POData },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                toast.success(`${POData} Created successfully`);
                setLoader(false);
                navigate("/Inventory/Stock/Adjustment")
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
        } catch (error) {
            setLoader(false);
            console.error('Error fetching items:', error);
        }
    };
    const UpdatePR = async () => {
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleAdjReason = (selectedOption) => {
        setFormData({ ...formData, adjReason: selectedOption });
    };
    const handlelocChange = (selectedOption) => {
        setFormData({ ...formData, location: selectedOption });
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) =>
                    attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment
                ),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    const handleDelete = (id) => {
        const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    };
   const handleCost1 = async (selectedOption) => {
        let param = `?CostCenter1=${selectedOption?.label}`
        let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
        if (cost2?.data?.result) {
            setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
        } else {
            setCost2([])
        }
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }
    return (
        <div className='px-4 pb-5'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Stock Adjustment</h5>
                <div className='d-flex gap-3'>
                    {itemData?.eye === true ? " " :
                        <>
                            {location.state ? (
                                <>{loader === true ?
                                    <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                    <button className='mainbtn ' onClick={UpdatePR}>
                                        <FaSave className='center mt-1 mx-2' /><div>Update</div>
                                    </button>
                                }</>
                            ) : (
                                <>{loader === true ?
                                    <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                    <button className='mainbtn ' type="submit" onClick={CreatePR}>
                                        <FaSave className='center mt-1 mx-2' /><div>Save</div>
                                    </button>
                                }</>)}
                        </>}
                    {itemData?.eye === true ? " " : <button className='mainbtnRed' ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>}
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Adjustment Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="recordId" className="form-label  pt-2 start">Adjustment No</label>
                                <input
                                    className="form-Input w-70"
                                    disabled
                                    value={POData}
                                    name="recordId"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled
                                        value={formData.costCenter1}
                                    /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        isSearchable={true}
                                        value={formData.costCenter1}
                                        options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                        onChange={handleCost1}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="catcode" className="form-label  pt-2 start">Adjustment Date </label>
                                {itemData?.eye === true ?
                                    <input
                                        className='form-Input w-70'
                                        type='date' disabled
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                    /> :
                                    <input
                                        className='form-Input w-70'
                                        type='date'
                                        defaultValue={new Date().toISOString().substr(0, 10)}
                                        name="requisitionDate"
                                        onChange={handleInputChange}
                                    />
                                }
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Unit</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled
                                        value={formData.costCenter2}
                                    /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.costCenter2}
                                        onChange={handleCost2}
                                        options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Adjustment Reason</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled value={formData.costCenter1} /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData?.adjReason}
                                        onChange={(selectedOption) => handleAdjReason(selectedOption)}
                                        options={staticOptions?.map((res) => ({ value: res, label: res?.name }))}
                                    />}
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Cost Center 3</label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled value={formData.costCenter3} /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.costCenter3}
                                        onChange={handleCost3}
                                        options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    />}
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Location </label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled /> :

                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData?.location}
                                        onChange={(selectedOption) => handlelocChange(selectedOption)}
                                        options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 4 </label>
                                {itemData?.eye === true ?
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }} isDisabled
                                        value={formData.costCenter4} /> :
                                    <Select
                                        className="w-70 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        value={formData.costCenter4}
                                        onChange={handleCost4}
                                        options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    />
                                }
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="remarks" className="form-label  pt-2 start">Remarks</label>
                                {itemData?.eye === true ?
                                    <input disabled
                                        className="form-Input w-70"
                                        value={formData.remarks}
                                    /> :
                                    <input
                                        name="remarks"
                                        type='text'
                                        className="form-Input w-70"
                                        id="remarks"
                                        value={formData.remarks}
                                        onChange={handleInputChange}
                                    />}
                            </div>
                        </div>
                        {/* <div className='form-group row'>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center p-2" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>

                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 ">
                {gridVisibility[0] && (
                    <StockAdjGrid onRequisitionData={handleRequisitionData} itemData={itemData} selectedLocation={formData.location}
                        currencyPrecision={currencyPrecision?.precision || 3} />

                )}
                {gridVisibility[1] && (
                    <IssueAuthorization
                        handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={itemData}
                    />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        <IssueMessageGrid handleMessage={handleMessage} />
                    </div>
                )}

            </div>
            <div>
                <Modal show={attachmentModal} size="lg" onHide={handleClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Attachments</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col d-flex justify-content-between">
                            <label htmlFor="docNp" className="form-label  pt-2 start">Document No</label>
                            <input disabled value={POData} className="form-Input w-70" />
                        </div>
                        <div className="pt-2">
                            <table>
                                <thead className="dynoTable">
                                    <tr>
                                        <th>File Name</th>
                                        <th>Remarks</th>
                                        <th>Upload</th>
                                        <th>View</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachmentList?.map((attachment, index) => (
                                        <tr key={attachment.id}>
                                            <td className='m-0 p-0'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "320px" }} /></td>
                                            <td>
                                                <input type="text" value={attachment.remarks}
                                                    onChange={(e) => {
                                                        const updatedList = attachmentList?.map((item) =>
                                                            item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                        );
                                                        setAttachmentList(updatedList);
                                                    }}
                                                    style={{ width: '345px' }}
                                                />
                                            </td>
                                            <td>
                                                <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                                <input
                                                    type="file" accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileSelect(e, attachment.id)}
                                                    id={`fileInput-${attachment.id}`}
                                                />
                                            </td>
                                            <td><button className='mainbtnRed ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                                <div>View</div></button></td>
                                            <td>
                                                <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary'>
                                                    <div>Delete</div></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='mainbtn' onClick={handleClose} >Attach</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>Image Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                    </Modal.Body>
                </Modal>
            </div>
            <Modal size="md"
                show={docModal} onHide={() => setDocModal(false)}
                backdrop="static"
                contentLabel='Doc Id Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">Stock Adjustment Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger">
                        The Stock Adjustment number already exists. Click "Generate" to assign a new number.
                    </p>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                    <button className='mainbtnRed' onClick={GenerateNumber}>Generate</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default CreateStockAdj